import styles from "./SamplePrompts.module.css";

interface Props {
    onPromptClick: (prompt: string) => void;
    isMobile?: boolean;
}

const samplePrompts = [
    "¿Qué es el Plan Maestro Ferroviario?",
    "¿Cómo funciona el hidrógeno verde?",
    "¿Qué son los buses eléctricos ZEBRA?"
];

export const SamplePrompts = ({ onPromptClick, isMobile }: Props) => {
    // Mostramos siempre los 3 prompts
    const displayedPrompts = samplePrompts;

    return (
        <div className={styles.container}>
            <div className={styles.promptsGrid}>
                {displayedPrompts.map((prompt, index) => (
                    <button
                        key={index}
                        className={`${styles.promptButton} ${isMobile ? styles.promptButtonMobile : ''}`}
                        onClick={() => onPromptClick(prompt)}
                    >
                        {prompt}
                    </button>
                ))}
            </div>
        </div>
    );
};